import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { VillageTransportCostEntity } from './village-transport.entity';
import { VillageTransportService } from './village-transport.service';
import { VillageTransportCostController } from './village-transport.controller';

@Module({
    imports: [
        TypeOrmModule.forFeature([VillageTransportCostEntity])
    ],
    controllers: [VillageTransportCostController],
    providers: [VillageTransportService, ApplicationExceptionHandler],
    exports: [VillageTransportService]
})
export class VillageTrasportModule {}
